
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import Testimonials from './TestimonialKeyword';
import Accordion from './Accordion';

function Carhireinpune() {



    const cardData =
    {
        keyword: 'Car Hire in Pune',
        heading: 'Meghana Cab : Car Hire in Pune',
        headingDescription: 'Meghana Cab offers reliable Car Hire in Pune, providing flexible and affordable rental options for all your travel needs. Whether it is a business meeting, city tour, wedding event, or airport transfer, we have a wide range of well-maintained cars with professional chauffeurs ready to serve you. Enjoy hourly, daily, or long-term rentals with transparent pricing, on-time service, and 24/7 support. Book your car hire in Pune with Meghana Cab and experience the perfect combination of comfort, convenience, and value.',


        top: 'Top Places to Visit in Pune with Meghana Cab',

"topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Built in 1732 by the Peshwas, Shaniwar Wada is a grand fortification in the heart of Pune. Once the political center of the Maratha Empire, it features massive gateways, ancient ruins, and a famous evening light and sound show that narrates its rich history. A must-visit for heritage lovers. 🏰"
  },
  {
    "title": "Aga Khan Palace",
    "description": "This majestic palace was built in 1892 and played a pivotal role during India’s freedom struggle. It served as a prison for Mahatma Gandhi, Kasturba Gandhi, and others. With lush gardens and a museum preserving Gandhi’s belongings, it’s a serene site filled with historic significance. 🕊️"
  },
  {
    "title": "Sinhagad Fort",
    "description": "Perched on a cliff about 30 km from Pune, Sinhagad Fort is famed for the 1670 battle led by Tanaji Malusare. Trekking up offers stunning views, historical ruins, and rustic snacks like pithla bhakri served by local villagers. Ideal for history buffs and adventure seekers. 🗻"
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "This museum houses an eclectic collection of over 20,000 artifacts collected by Dr. Dinkar Kelkar. From sculptures and musical instruments to weapons and everyday items from different eras, it’s a treasure trove showcasing India’s rich cultural heritage. 🏺"
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Dating back to the 8th century, this rock-cut temple dedicated to Lord Shiva is carved from a single basalt rock. With its monolithic architecture, tranquil ambiance, and sacred sanctum, it's a hidden gem in Pune’s city center. 🕉️"
  },
  {
    "title": "Khadakwasla Dam",
    "description": "Located just outside Pune, this dam is a favorite for locals seeking scenic drives, lakeside relaxation, and street food. The cool breeze, reflections on the water, and nearby picnic spots make it ideal for a peaceful escape. 🌊"
  },
  {
    "title": "Pune Okayama Friendship Garden",
    "description": "Inspired by Japan’s Korakuen Garden, this beautifully landscaped garden in Pune features flowing streams, bridges, lush greenery, and koi ponds. Perfect for quiet strolls, family time, and photography. 🌸"
  },
  {
    "title": "Osho International Meditation Resort",
    "description": "Located in Koregaon Park, this tranquil center is dedicated to meditation, mindfulness, and holistic wellness. Visitors from around the world come here for dynamic meditation, spa therapies, and peaceful surroundings. 🌿"
  },
  {
    "title": "Fergusson College Road",
    "description": "A buzzing street in Pune known for its youthful vibe, cafes, street food, bookstores, and fashion boutiques. It’s a favorite hangout spot among students and a perfect place to experience Pune’s vibrant urban culture. ☕"
  },
  {
    "title": "Lal Mahal",
    "description": "Originally built in 1630 by Shivaji Maharaj’s father Shahaji Bhosale, this historic red palace is where young Shivaji spent part of his childhood. The present-day structure contains paintings and exhibits that celebrate his life and legacy. 🔴"
  }
],

"services": [
    {
        "name": "Affordable Car Rental Pune",
        "description": "Meghana Cab offers budget-friendly car rental services in Pune. Whether it’s a short ride or an outstation trip, enjoy reliable and cost-effective options tailored to your travel needs."
    },
    {
        "name": "AC Car Hire in Pune",
        "description": "Travel in comfort with Meghana Cab’s air-conditioned car hire service in Pune. Ideal for all seasons, our cars ensure a pleasant and relaxed journey for every customer."
    },
    {
        "name": "Outstation Car Hire Pune",
        "description": "Planning a trip outside the city? Hire cars for outstation travel from Pune with Meghana Cab. Enjoy clean vehicles, expert drivers, and flexible rental options for any destination."
    },
    {
        "name": "Self Drive Car Rental Pune",
        "description": "Prefer to drive yourself? Meghana Cab provides self-drive car rental options in Pune for individuals seeking privacy, flexibility, and freedom on the road."
    },
    {
        "name": "Chauffeur Driven Car Hire Pune",
        "description": "Relax while our professional chauffeurs drive you across Pune or outstation. Meghana Cab’s chauffeur-driven car hire service ensures a luxurious and hassle-free experience."
    },
    {
        "name": "Online Car Booking Pune",
        "description": "Book your car online with Meghana Cab’s simple and fast car rental platform in Pune. Choose your vehicle, schedule, and ride with instant confirmation."
    },
    {
        "name": "SUV and Sedan Rental in Pune",
        "description": "Whether you need a spacious SUV or a sleek sedan, Meghana Cab offers a wide range of car types for rent in Pune, perfect for all travel styles and group sizes."
    },
    {
        "name": "Long-Term Car Hire Pune",
        "description": "Need a car for more than a day? Meghana Cab provides long-term car hire services in Pune with flexible plans for corporate use, relocation, or extended vacations."
    },
    {
        "name": "Car Hire for Events in Pune",
        "description": "Hire cars for events, functions, or corporate gatherings in Pune with Meghana Cab. We provide clean, elegant vehicles to meet your occasion’s needs."
    },
    {
        "name": "Luxury Car Rental Pune",
        "description": "Upgrade your ride with Meghana Cab’s luxury car rentals in Pune. Perfect for weddings, VIP guests, or premium travel experiences across the city or beyond."
    },
    {
        "name": "Short-Term Car Rental Pune",
        "description": "Need a car for a few hours or a day? Meghana Cab’s short-term car rental service in Pune is perfect for quick errands, meetings, or city tours."
    },
    {
        "name": "Car Hire for Airport Transfers Pune",
        "description": "Get on-time airport transfers with Meghana Cab’s reliable car hire service in Pune. Whether it’s pickup or drop, we ensure smooth and timely travel to and from the airport."
    },
    {
        "name": "Budget Car Rentals Pune",
        "description": "Looking for a low-cost rental? Meghana Cab offers affordable car rentals in Pune with transparent pricing and no hidden charges for local or outstation trips."
    },
    {
        "name": "Daily Car Hire Service Pune",
        "description": "Meghana Cab provides daily car hire services in Pune with flexible timing and professional support. Ideal for personal, tourist, or corporate use."
    },
    {
        "name": "24/7 Car Booking Pune",
        "description": "Book your car anytime, anywhere in Pune with Meghana Cab’s 24/7 car booking service. Available round-the-clock for emergencies, late-night rides, or early departures."
    }
],

"tableData": [
    ["Affordable Car Rental Pune", "AC Car Hire in Pune"],
    ["Outstation Car Hire Pune", "Self Drive Car Rental Pune"],
    ["Chauffeur Driven Car Hire Pune", "Online Car Booking Pune"],
    ["SUV and Sedan Rental in Pune", "Long-Term Car Hire Pune"],
    ["Car Hire for Events in Pune", "Luxury Car Rental Pune"],
    ["Short-Term Car Rental Pune", "Car Hire for Airport Transfers Pune"],
    ["Budget Car Rentals Pune", "Daily Car Hire Service Pune"],
    ["24/7 Car Booking Pune", ""],
    ["", ""]
],











"whychoose": [
    {
        "WhyChooseheading": "Affordable and Flexible Car Hire in Pune",
        "WhyChoosedescription": "Meghana Cab offers convenient and budget-friendly car hire services in Pune for all types of travel—whether it's business meetings, local sightseeing, airport transfers, or outstation trips."
    },
    {
        "WhyChooseheading": "Wide Range of Vehicles to Choose From",
        "WhyChoosedescription": "Choose from a variety of cars including hatchbacks, sedans, SUVs, and luxury vehicles based on your comfort, group size, and travel needs. We have the perfect car for every journey."
    },
    {
        "WhyChooseheading": "Hourly, Daily, and Long-Term Rentals",
        "WhyChoosedescription": "Need a car for a few hours or several days? Meghana Cab provides flexible rental options—hourly, full-day, or long-term car hire in Pune tailored to your schedule."
    },
    {
        "WhyChooseheading": "Professional Drivers for a Hassle-Free Experience",
        "WhyChoosedescription": "All our car hire services come with experienced, courteous drivers who know Pune’s roads well. Sit back and relax while we take care of your travel."
    },
    {
        "WhyChooseheading": "Clean, Well-Maintained and Sanitized Cars",
        "WhyChoosedescription": "Travel in comfort and safety. Our cars are regularly cleaned, sanitized, and serviced to provide a smooth, hygienic, and secure ride every time."
    },
    {
        "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
        "WhyChoosedescription": "With Meghana Cab, what you see is what you pay. Enjoy fully transparent pricing with no hidden fees or last-minute surprises on your car hire bill."
    },
    {
        "WhyChooseheading": "24/7 Car Hire Services in Pune",
        "WhyChoosedescription": "We operate around the clock to suit your convenience. Whether it’s an early morning pick-up or a late-night drop, our car hire services in Pune are always available."
    },
    {
        "WhyChooseheading": "Quick and Easy Booking Process",
        "WhyChoosedescription": "Hire a car in Pune effortlessly through our website or mobile app. Our support team is also available to help with any special requests or custom travel plans."
    }
]




























    }

const faqData = [
    {
        question: "How can I hire a car in Pune with Meghana Cab?",
        answer: "You can hire a car in Pune easily through Meghana Cab by calling +91 9075462128 or booking online via our website."
    },
    {
        question: "What types of cars are available for hire in Pune?",
        answer: "Meghana Cab offers hatchbacks, sedans, SUVs, and tempo travellers to meet various travel needs and group sizes."
    },
    {
        question: "Can I hire a car in Pune with or without a driver?",
        answer: "All Meghana Cab rentals come with experienced drivers to ensure a safe and hassle-free journey."
    },
    {
        question: "Is car hire available for both local and outstation travel in Pune?",
        answer: "Yes, we provide car hire services for both local city use and outstation travel from Pune."
    },
    {
        question: "Are your car hire services available 24/7 in Pune?",
        answer: "Yes, our car hire services are available 24/7. You can book a car anytime as per your convenience."
    },
    {
        question: "What documents are needed to hire a car in Pune?",
        answer: "No documents are needed from your end as our rentals include a professional driver. Just share your pickup details and travel plan."
    },
    {
        question: "Can I hire a car in Pune for a few hours only?",
        answer: "Yes, we offer hourly car hire services in Pune for short trips, errands, and meetings."
    },
    {
        question: "Are tolls and parking included in the car hire charges?",
        answer: "Tolls, parking, and any interstate taxes are additional and shared transparently during the booking process."
    },
    {
        question: "What are the payment options for car hire in Pune?",
        answer: "We accept UPI, credit/debit cards, net banking, and cash for all car hire bookings."
    },
    {
        question: "How do I contact Meghana Cab for car hire in Pune?",
        answer: "To hire a car in Pune, call Meghana Cab at +91 9075462128. Our team is available 24/7 to assist you."
    }
];

const testimonialsData = [
    {
        name: 'Mr. Nilesh Pawar',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“I hired a car in Pune from Meghana Cab for a business meeting. The car was clean, the driver was polite, and the ride was very smooth.”',
    },
    {
        name: 'Ms. Pooja Shelar',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“Meghana Cab provided excellent car hire service in Pune. Booking was quick and the service was professional.”',
    },
];





















































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9075462128",
            "+91 8452916550",

        ],
        email: "booking@meghanacabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Online Cab Booking in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Kolhapur Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Satara Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Hyderabad Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune to Bangalore Cab",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Pune to Indore Cab",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Gujarat Cab",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Lonavala Taxi",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Pune to Jejuri Cab",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Local Taxi Service in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pune to Lavasa Cab",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Pune to Kashid Beach Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "One Way Cab Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Round Trip Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Taxi Service Near Me",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Car Hire in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Seater Car on Rent in Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Cab Service in Pimpri Chinchwad",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune Taxi Cab Services",
        },
        {
            place: "/images/keyword/20.jpg",
            text: "Pune Airport Taxi",
        },

        {
            place: "/images/keyword/21.jpg",
            text: "Pune to Rajasthan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Pune to Matheran Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Pandharpur Cab",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Mumbai Cabs",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Pune to Mumbai Airport Cab ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to Mumbai Taxi",
        },
    ];


    const images = [
        { src: "/images/booking/1.jpg", alt: "Image 1" },
        { src: "/images/booking/5.jpg", alt: "Image 1" },
        { src: "/images/booking/2.jpg", alt: "Image 1" },
        { src: "/images/booking/3.jpg", alt: "Image 1" },
        { src: "/images/booking/4.jpg", alt: "Image 1" },
        { src: "/images/booking/7.jpg", alt: "Image 1" },
        { src: "/images/booking/8.jpg", alt: "Image 1" },
        { src: "/images/booking/9.jpg", alt: "Image 1" },
        { src: "/images/booking/6.jpg", alt: "Image 1" },

    ];







const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Car Hire in Pune",
  "image": "https://www.meghanacabs.com/assets/images/car-hire-pune.jpg",
  "description": "Affordable car hire in Pune with Meghana Cabs. Choose from AC, SUV, sedan rentals, self-drive or chauffeur-driven cars for outstation trips, events, and airport transfers.",
  "brand": {
    "@type": "Brand",
    "name": "Meghana Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "5256"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1000",
    "availability": "https://schema.org/InStock",
    "url": "https://www.meghanacabs.com/car-hire-pune"
  }
};






    return (
        <div>
<Helmet>
  <title>Car Hire in Pune | Affordable & Luxury Rentals | Meghana Cabs</title>
  <meta 
    name="description" 
    content="Affordable car hire in Pune with Meghana Cabs. Choose from AC, SUV, sedan rentals, self-drive or chauffeur-driven cars for outstation trips, events, and airport transfers." 
  />
  <meta 
    name="keywords" 
    content="Affordable Car Rental Pune, AC Car Hire in Pune, Outstation Car Hire Pune, Self Drive Car Rental Pune, Chauffeur Driven Car Hire Pune, Online Car Booking Pune, SUV and Sedan Rental in Pune, Long-Term Car Hire Pune, Car Hire for Events in Pune, Luxury Car Rental Pune, Short-Term Car Rental Pune, Car Hire for Airport Transfers Pune, Budget Car Rentals Pune, Daily Car Hire Service Pune, 24/7 Car Booking Pune" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>



            <section className="page-title centred">
                <div className="bg-layer" style={{ backgroundImage: 'url(/images/page-header-bg.jpg)' }}></div>
                <div className="auto-container">
                    <div className="content-box">

                        <h1>{cardData.keyword}</h1>
                    </div>
                </div>
            </section>




            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/16.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#F2614C', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                             <h3 className='pt-md-3 text-dark'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Meghana Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <Accordion data={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3 className=' text-dark'>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F1604F',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F1604F' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919075462128" className="d-block  text-white">+91 9075462128</a>
                                                <a href="tel:+918452916550" className="d-block  text-white">+91 8452916550</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@meghanacabs.com" className=" text-white d-block">
                                                    booking@meghanacabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Meghana Cab  <br />
                                                        Yelwande Wasti. Opp Vithal Lawans, Laxmi Chowk, Hinjawadi, Pune - 411057
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Carhireinpune;